import { create } from 'zustand';
import { systemService } from '../services/system';

interface FeatureFlags {
  enable_pixel_feature?: boolean;
  enable_billing?: boolean;
  enable_ip_stats?: boolean;
  enable_operation_logs?: boolean;
  [key: string]: boolean | undefined;
}

interface SystemConfig {
  system_name?: string;
  version?: string;
  feature_flags?: FeatureFlags;
}

interface SystemConfigState {
  config: SystemConfig | null;
  featureFlags: FeatureFlags;
  loaded: boolean;
  loading: boolean;
  error: string | null;
  fetchConfig: () => Promise<void>;
  isFeatureEnabled: (featureKey: string) => boolean;
}

export const useSystemConfigStore = create<SystemConfigState>((set, get) => ({
  config: null,
  featureFlags: {},
  loaded: false,
  loading: false,
  error: null,

  fetchConfig: async () => {
    const { loaded, loading } = get();
    
    // 避免重复加载
    if (loaded || loading) {
      return;
    }

    set({ loading: true, error: null });

    try {
      const config = await systemService.getSystemConfig();
      const featureFlags = config.feature_flags || {};
      
      set({
        config,
        featureFlags,
        loaded: true,
        loading: false,
        error: null,
      });

      console.log('✅ 系统配置加载成功:', config);
    } catch (error: any) {
      console.error('❌ 系统配置加载失败:', error);
      set({
        error: error.message || '加载系统配置失败',
        loading: false,
        loaded: false,
      });
    }
  },

  isFeatureEnabled: (featureKey: string) => {
    const { featureFlags } = get();
    return featureFlags[featureKey as keyof FeatureFlags] !== false;
  },
}));
